import { call, put, takeLatest } from 'redux-saga/effects';
import { getSubjects, sendFeedback } from '../../services/API/index';

import {
  actionTypes,
  requestFailure,
  requestSuccess,
  requestThemesFailure,
  requestThemesSuccess,
} from './actions';

function* sendSaveRequest(action) {
  const response = yield call(sendFeedback, action.payload);
  yield put(response.isOk ? requestSuccess() : requestFailure(response.error));
}

function* sendSubjectsRequest() {
  const responce = yield call(getSubjects);
  yield put(
    responce.isOk ? requestThemesSuccess(responce.data) : requestThemesFailure(responce.error),
  );
}

export default {
  saveFeedbackSaga: function* saveFeedbackSaga() {
    yield takeLatest(actionTypes.REQUEST_START, sendSaveRequest);
  },
  getSubjectsSaga: function* getSubjectsSaga() {
    yield takeLatest(actionTypes.REQUEST_THEMES_START, sendSubjectsRequest);
  },
};
